export default {
  label: {
    aggregationText: 'Total of ',
    aggregationTextAvgSAC: 'Average Capture Time',
    notShowClassifiedLabel: 'Show unclassified',
    showClassifiedLabel: 'Hide unclassified',
    filter: {
      button_filter: 'Apply Filter',
    },
    viewTags: {
      button_viewTags: 'View tags',
    },
  },
  aggregationType: {
    listening: 'posts',
    sac: 'interactions',
    'sac-listening': 'posts + interactions',
    default: 'posts',
  },
};
